var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"ml-1 extra-small",attrs:{"size":"sm","variant":"outline-secondary","disabled":_vm.isLoading},on:{"click":_vm.confirmarTroca}},[(_vm.isLoading)?_c('b-spinner',{staticClass:"align-middle",attrs:{"small":""}}):_c('font-awesome-icon',{attrs:{"icon":"refresh"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }